import { cn as r } from "../../../lib/utils.es.js";
import { jsx as b } from "react/jsx-runtime";
var t = ({ className: i, ...l }) => /* @__PURE__ */ b("textarea", {
  className: r("lib:field-sizing-content lib:flex lib:min-h-16 lib:w-full lib:rounded-lg lib:border lib:border-input lib:bg-white lib:px-2.5 lib:py-2 lib:text-base lib:shadow lib:outline-none lib:transition-colors lib:placeholder:text-muted-foreground lib:focus-visible:border-ring lib:focus-visible:ring-3 lib:focus-visible:ring-ring/50 lib:disabled:cursor-not-allowed lib:disabled:bg-input/50 lib:disabled:opacity-50 lib:aria-invalid:border-destructive lib:aria-invalid:ring-3 lib:aria-invalid:ring-destructive/20 lib:md:text-sm dark:lib:bg-input/30 dark:lib:aria-invalid:border-destructive/50 dark:lib:aria-invalid:ring-destructive/40 dark:lib:disabled:bg-input/80", i),
  "data-slot": "textarea",
  ...l
});
export {
  t as Textarea
};
